var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import { Divider, Stack, useMediaQuery } from '@mui/material';
import { ThemeProvider } from "@mui/material/styles";
import theme from '../theme';
import { isString } from 'lodash';
function isHTML(str) {
    var doc = new DOMParser().parseFromString(str, "text/html");
    return Array.from(doc.body.childNodes).some(function (node) { return node.nodeType === 1; });
}
var ItemHeader = function (props) {
    var isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    return (_jsx(ThemeProvider, __assign({ theme: theme }, { children: _jsxs(Stack, __assign({ direction: 'column', flex: 1 }, { children: [_jsxs(ListItem, __assign({ disableGutters: true, secondaryAction: props.components && props.components.menu && props.components.menu(__assign({}, props)), sx: {
                        alignItems: 'center',
                        textAlign: isMobile ? 'center' : 'left',
                        flexDirection: isMobile ? 'column' : 'row',
                        pr: 1,
                        '& .MuiListItemSecondaryAction-root': isMobile ? {
                            position: 'relative',
                            top: 0,
                            transform: 'unset',
                            display: 'flex'
                        } : {
                            position: 'relative',
                            display: 'flex',
                            transform: 'unset',
                        }
                    } }, { children: [props.components && props.components.avatar &&
                            _jsx(ListItemAvatar, { children: props.components.avatar(__assign({}, props)) }), _jsx(ListItemText, { sx: { color: "var(--palette-black-1)" }, primary: isString(props.name) ?
                                _jsx("div", __assign({ style: { fontSize: '24px', fontWeight: 600 } }, { children: props.name }))
                                :
                                    props.name(), secondary: isString(props.description) ?
                                _jsx("div", __assign({ style: { fontSize: '13px', fontWeight: 600 } }, { children: _jsx("div", { dangerouslySetInnerHTML: { __html: props.description } }) }))
                                :
                                    props.description() })] })), !props.hideDivider && _jsx(_Fragment, { children: _jsx(Divider, { sx: { borderBottom: "1px solid var(--palette-secondary-light)", pt: 3 } }) })] })) })));
};
export default ItemHeader;
